var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { fill: "currentColor", x: 11, y: 11, width: 26, height: 26, rx: 5 }),
            React.createElement("circle", { stroke: "#FFF", strokeWidth: 2, cx: 19, cy: 19, r: 3 }),
            React.createElement("path", { d: "M22.693 26.775l-2.218 2.218 2.218 2.219a1.048 1.048 0 01-1.383 1.568l-.099-.087-2.218-2.218-2.217 2.217a1.04 1.04 0 01-1.471-1.47l2.217-2.218-2.215-2.213a1.048 1.048 0 01-.087-1.383l.087-.1c.41-.408 1.073-.408 1.482 0l2.215 2.214 2.218-2.217a1.04 1.04 0 011.471 1.47zM32.693 16.775l-2.218 2.218 2.218 2.219a1.048 1.048 0 01-1.383 1.568l-.099-.087-2.218-2.218-2.217 2.217a1.04 1.04 0 01-1.471-1.47l2.217-2.218-2.215-2.213a1.048 1.048 0 01-.087-1.383l.087-.1c.41-.408 1.073-.408 1.482 0l2.215 2.214 2.218-2.217a1.04 1.04 0 011.471 1.47z", fill: "#FFF" }),
            React.createElement("circle", { stroke: "#FFF", strokeWidth: 2, cx: 29, cy: 29, r: 3 }))));
});
